package app.vercors.website.pages.blog

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initWelcomePage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("blog/welcome.md", FrontMatterElement.Builder { addScalar("title", "Welcome to the Vercors blog"); addScalar("date", "2026-10-12"); addScalar("description", "Welcome to the Vercors blog! This is the first post, and I honestly don't know what to write yet."); }))
}

@Page("/blog/welcome")
@Layout(".components.layouts.BlogPostLayout")
@Composable
fun WelcomePage() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Welcome to the Vercors blog! This is the first post, and I honestly don't know what to write yet.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The development of Vercors is still ongoing, and I'm excited to share updates as I progress. So, expect more posts in the future!")
    }
}
